module.exports = __webpack_public_path__ + "img/CMR.6fa23c1d.svg";